import {ValueObject} from '@s-ui/domain'

import {FilterAggregationsSearchValueObject} from './FilterAggregationsSearchValueObject.js'

export class FiltersAggregationsSearchValueObject extends ValueObject {
  #aggregations

  constructor({aggregations}) {
    super()
    this.#aggregations = aggregations
  }

  static createFromListingApi({aggregations}) {
    return new FiltersAggregationsSearchValueObject({
      aggregations: aggregations.map(({name, items}) =>
        FilterAggregationsSearchValueObject.createFromListingApi({name, aggregations: items || []})
      )
    })
  }

  static createFromApi({aggregations}) {
    return new FiltersAggregationsSearchValueObject({
      aggregations: aggregations.map(({name, items}) =>
        // WiP: Handle category1Id differently to avoid renting offer type
        // This is a temporary solution until we have a better way to handle renting offers
        name === 'category1Id'
          ? FilterAggregationsSearchValueObject.createWithoutRentingOfferType({name, items})
          : FilterAggregationsSearchValueObject.createFromPrimitives({name, items})
      )
    })
  }

  get aggregations() {
    return this.#aggregations.map(aggregation => aggregation.getValue())
  }

  getValue() {
    return {aggregations: this.aggregations}
  }

  getCategoryAggregationWithHighestTotalResults() {
    const [aggregations] = this.#aggregations.filter(aggregation => aggregation.isCategoryAggregation())
    return aggregations.itemWithHighestTotalResults()
  }

  getCategoryAggregations() {
    const [aggregations] = this.#aggregations.filter(aggregation => aggregation.isCategoryAggregation())
    return aggregations.items
  }

  getCategoryAggregationsTotalResults() {
    const [aggregations] = this.#aggregations.filter(aggregation => aggregation.isCategoryAggregation())
    return aggregations.getTotalResults()
  }
}
